module.exports = __webpack_public_path__ + "media/src/images/icons/dash_dash-5f09a6b1694d140347ea319a76f13b4a.svg";